export const FORM_DATE_PICKER_POPUP_CLASSNAME = 'form-date-picker';
